export default "__VITE_ASSET__DdJdAQuk__";